module.exports = __webpack_public_path__ + "static/media/Flaticon.6758abe2.eot";